import React from "react";
var __jsx = React.createElement;
import stl from "./OrderCanceled.module.css";
import NeedHelp from "@/_MiniApps/NeedHelp/NeedHelp";
import { URL_SELL_TRADE_FORM_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { useTranslation } from "@i18n";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
var OrderCanceled = function OrderCanceled(_ref) {
  var text = _ref.text,
    _ref$pageData = _ref.pageData,
    pageData = _ref$pageData === void 0 ? null : _ref$pageData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var webview = useWebView();
  var isWebView = useIsWebView();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("strong", null, text), (pageData === null || pageData === void 0 ? void 0 : pageData.fees_amount) !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, (pageData === null || pageData === void 0 ? void 0 : pageData.is_refundable) === 1 && /*#__PURE__*/React.createElement("p", null, t("inspection_fee_refunded_card_soon", {
    ns: "web_Schedule"
  })), (pageData === null || pageData === void 0 ? void 0 : pageData.is_refundable) === 0 && /*#__PURE__*/React.createElement("p", null, t("kindly_note_inspection_fee_cannot", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("a", {
    className: [stl.btn, "blueBtn"].join(" "),
    href: createUrl(URL_SELL_TRADE_FORM_v2)
  }, t("submit_new_request", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "whtBtn"].join(" "),
    onClick: function onClick() {
      webview.closeScreen()["catch"](function () {
        if (isWebView) return document.location.href = "app://close";
        document.location.href = createUrl("/");
      });
    }
  }, t("go_homepage", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement(NeedHelp, {
    className: [stl.helpContainer].join(" ")
  }));
};
export default OrderCanceled;